/**
 * IMPORTANT
 * This file is exclusively for Vue 3 usage.
 *
 * For shared functionality between Vue 2 and Vue 3,
 * use the common parent class `EpsilonTaggingManagerBase`.
 *
 * Any common methods should be implemented in the parent class to ensure reusability.
 *
 * Any changes made here should also be made in the Vue2 file
 * Vue3 file: current file
 * Vue2 file: js/services/EpsilonTaggingManager/OEMTagManagers/EpsilonVolvoTagging.js
 *
 * For further details, please contact Leela.
 *
 */

import { EpsilonTaggingManagerBase } from '../../../../../js/services/EpsilonTaggingManager/EpsilonTaggingManagerBase';
import { ExpressPayments } from '@vue3/src/Services/Payments/ExpressPayments';

export class EpsilonVolvoTagging extends EpsilonTaggingManagerBase {
  constructor() {
    super();
  }

  // get vehicle details
  async getVehicleDetails(vin) {
    let vehicleData = await ExpressPayments.getVehicleDetails(vin);
    return {
      vehicle_model_year: vehicleData.year,
      vehicle_make: vehicleData.make,
      vehicle_model: vehicleData.model,
      vehicle_trim: vehicleData.trim,
      vehicle_color: vehicleData.exteriorColor,
      vehicle_body_style: vehicleData.body,
      vehicle_condition: vehicleData.type,
      vehicle_price: vehicleData.sellingPrice,
      vehicle_options: vehicleData.options.split(',').filter(Boolean).join(','),
      vehicle_class: vehicleData.passengerCapacity,
    };
  }
}
